import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import TourCard from "@/components/TourCard";

export default function Tours() {
  const { t } = useLang();
  const [tours, setTours] = useState([]);
  useEffect(() => {
    api.get("/tours").then((r) => setTours(r.data || [])).catch(() => {});
  }, []);
  return (
    <div data-testid="tours-page" className="pt-24 md:pt-28 pb-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">{t.home.tours_overline}</p>
        <h1 className="font-serif-display text-4xl md:text-6xl tracking-tight font-light text-charcoal leading-[1.05] max-w-3xl">
          {t.nav.tours}
        </h1>
        <p className="mt-5 max-w-xl text-charcoal-400 text-base md:text-lg">{t.home.tours_sub}</p>

        <div className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-10">
          {tours.map((tour, i) => (
            <TourCard key={tour.id} tour={tour} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
